import { createStyles } from '@codeleap/styles'
import { textVariant } from './Text'
import { ProgressCircleComposition } from '@codeleap/web'
import { StyleRegistry } from '../styles'

const createProgressCircleVariant = createStyles<ProgressCircleComposition>

export const ProgressCircleStyles = {
  default: createProgressCircleVariant((theme) => ({
    wrapper: {},
    circle: {
      size: 160,
    },
    line: {
      borderColor: theme.baseColors.primarySolid300,
      backgroundColor: theme.baseColors.neutralSolid300,
    },
    image: {
      height: theme.values.iconSize[4],
      width: theme.values.iconSize[4],
    },
    innerWrapper: {
      ...theme.presets.column,
      ...theme.presets.alignCenter,
    },
    text: {
      ...textVariant('h2'),
      color: theme.baseColors.neutralSolid700,
    },
    icon: {
      size: theme.values.iconSize[4],
      color: theme.baseColors.neutralSolid700,
    },
  })),
}

StyleRegistry.registerVariants('ProgressCircle', ProgressCircleStyles)
